
import { Contact, Deal, DealStage, Activity, Task, Employee, Country } from './types';

// Helper to get date string relative to today
const getDate = (daysOffset: number) => {
  const date = new Date();
  date.setDate(date.getDate() + daysOffset);
  return date.toISOString().split('T')[0];
};

export const mockEmployees: Employee[] = [
  {
    id: 'emp1',
    name: 'John Doe',
    role: 'Sales Manager',
    accessLevel: 'Admin',
    avatarUrl: 'https://api.dicebear.com/7.x/avataaars/svg?seed=John'
  },
  {
    id: 'emp2',
    name: 'Alice Smith',
    role: 'Account Executive',
    accessLevel: 'User',
    avatarUrl: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Alice'
  },
  {
    id: 'emp3',
    name: 'Bob Jones',
    role: 'Sales Representative',
    accessLevel: 'User',
    avatarUrl: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Bob'
  }
];

export const mockContacts: Contact[] = [
  {
    id: '1',
    companyName: 'TechFlow Systems Ltd',
    companyAddress: 'Industrial Area, Plot 45, Dar es Salaam',
    poBox: 'P.O. Box 12345',
    tin: '100-200-300',
    vrn: 'VRN-001',
    email: 'sarah.chen@techflow.io',
    contactPerson: 'Sarah Chen',
    phone: '+255 754 000 001',
    role: 'CTO',
    lastContacted: getDate(-2),
    notes: 'Interested in AI automation for their customer support.',
    avatarUrl: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Sarah',
    sentiment: 'Positive',
    country: Country.TANZANIA
  },
  {
    id: '2',
    companyName: 'Apex Global Logistics',
    companyAddress: 'Mombasa Road, Nairobi, Kenya',
    poBox: 'P.O. Box 999',
    tin: 'KRA-9988-77',
    vrn: '',
    email: 'm.ross@apexglobal.com',
    contactPerson: 'Michael Ross',
    phone: '+254 722 000 999',
    role: 'VP of Operations',
    lastContacted: getDate(-5),
    notes: 'Budget approval pending for Q4.',
    avatarUrl: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Michael',
    sentiment: 'Neutral',
    country: Country.KENYA
  }
];

export const mockDeals: Deal[] = [
  {
    id: '101',
    contactId: '1',
    title: 'Enterprise License - TechFlow',
    value: 45000,
    stage: DealStage.NEGOTIATION,
    expectedCloseDate: getDate(20)
  },
  {
    id: '102',
    contactId: '2',
    title: 'Q4 Implementation',
    value: 28000,
    stage: DealStage.PROPOSAL,
    expectedCloseDate: getDate(35)
  }
];

export const mockActivities: Activity[] = [
  {
    id: 'a1',
    contactId: '1',
    type: 'Email',
    date: getDate(-2),
    description: 'Sent follow-up regarding API documentation.'
  }
];

export const mockTasks: Task[] = [
  {
    id: 't1',
    contactId: '1',
    assigneeId: 'emp1',
    title: 'Send contract draft for review',
    dueDate: getDate(0), 
    priority: 'High',
    status: 'Pending',
    country: Country.TANZANIA
  }
];
